// extracted by mini-css-extract-plugin
module.exports = {"pdpPromoTextRichtext":"PDPPromoText_pdpPromoTextRichtext__RFEvm"};